import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface RequestUpdateUnclaimedMoney {
  paymentReceivableId: number;
  token: string;
  paymentRef: string;
}

const updateUnclaimedMoney = async ({
  paymentReceivableId,
  token,
  paymentRef,
}: RequestUpdateUnclaimedMoney) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/update-unclaimed-money`,
      {
        paymentReceivableId,
        paymentRef,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.status;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    throw new Error(message);
  }
};

export default updateUnclaimedMoney;
